export default __webpack_public_path__ + "static/media/android_inactive.62fd96dc.png";